import { Link } from "react-router-dom";
import { UserPlus } from "lucide-react";

/**
 * Highlighted "Add My Profile" call-to-action pill used on every directory listing.
 */
export function AddMyProfileCTA({ testId = "add-my-profile-cta" }) {
  return (
    <Link
      to="/add-my-profile"
      className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-bold shadow-sm hover:-translate-y-0.5 transition-transform"
      style={{
        background: "linear-gradient(135deg,#F59E0B 0%,#F0C948 100%)",
        color: "#0F172A",
        border: "1px solid #E7DCB9",
      }}
      data-testid={testId}
    >
      <UserPlus className="w-4 h-4" />
      Add My Profile
    </Link>
  );
}

/**
 * Simple Prev / Next pagination footer used on directory listings.
 */
export function Pagination({ page, totalPages, onPrev, onNext, testId = "pagination" }) {
  if (totalPages <= 1) return null;
  return (
    <div className="mt-10 flex items-center justify-center gap-3" data-testid={testId}>
      <button
        type="button"
        onClick={onPrev}
        disabled={page <= 1}
        className="px-4 py-2 rounded-full border border-slate-200 text-sm font-semibold bg-white text-slate-700 hover:bg-sky-50 disabled:opacity-40 disabled:cursor-not-allowed"
        data-testid={`${testId}-prev`}
      >
        ← Previous
      </button>
      <span className="text-xs text-slate-500 font-medium" data-testid={`${testId}-info`}>
        Page {page} of {totalPages}
      </span>
      <button
        type="button"
        onClick={onNext}
        disabled={page >= totalPages}
        className="px-4 py-2 rounded-full text-sm font-semibold bg-sky-700 text-white hover:bg-sky-800 disabled:opacity-40 disabled:cursor-not-allowed"
        data-testid={`${testId}-next`}
      >
        Next Page →
      </button>
    </div>
  );
}
